import { createAction, props } from '@ngrx/store';
import { HospitalizationDto, PrehospiCreationDto } from 'src/app/api/models';

export const checkExistingPrehospi = createAction(
  '[Hospitalization] Check existing prehospi',
  props<{ siteId: number, insurerId: string, contractId: number }>()
);

export const checkExistingPrehospiSuccess = createAction(
  '[Hospitalization] Check existing prehospi success',
  props<{ data: HospitalizationDto }>()
);

export const checkExistingPrehospiFailure = createAction(
  '[Hospitalization] Check existing prehospi failure',
  props<{ error: any }>()
);

export const createPrehospi = createAction(
  '[Hospitalization] Create prehospi',
  props<{ data: PrehospiCreationDto }>()
);

export const createPrehospiSuccess = createAction(
  '[Hospitalization] Create prehospi success',
  props<{ data: HospitalizationDto }>()
);

export const createPrehospiFailure = createAction(
  '[Hospitalization] Create prehospi failure',
  props<{ error: any }>()
);

export const getMedicalForm = createAction("[Hospitalization] Get medical form", props<{ languageCode: string, hospitalizationId: number }>());
export const getMedicalFormSuccess = createAction("[Hospitalization] Get medical form success", props<{ data: File }>());
export const getMedicalFormFailure = createAction("[Hospitalization] Get medical form failure", props<{ error: any }>());

export const sendMedicalForm = createAction("[Hospitalization] Send medical form", props<{ languageCode: string, hospitalizationId: number, medicalForm: string, recipient: string }>());
export const sendMedicalFormSuccess = createAction("[Hospitalization] Send medical form success", props<{ data: any }>());
export const sendMedicalFormFailure = createAction("[Hospitalization] Send medical form failure", props<{ error: any }>());

export const getPrintLight = createAction("[Hospitalization] Get print light", props<{ languageCode: string, hospitalizationId: number,messageId:number }>());
export const getPrintLightSuccess = createAction("[Hospitalization] Get print light success", props<{ data: File }>());
export const getPrintLightFailure = createAction("[Hospitalization] Get print light failure", props<{ error: any }>());

export const resetHospi = createAction("[Hospitalization] Reset");